<template>
  <CoreDrawer
    :value="value"
    title="Прочее"
    data-qa="analyses_other_categories_drawer"
    @input="emit('input', $event)"
  >
    <div
      v-if="isLoading"
      class="px-4"
    >
      <v-skeleton-loader
        v-for="index in 6"
        :key="index"
        type="list-item"
        class="mb-2"
      />
    </div>

    <div
      v-else-if="isError"
      class="px-4 text-body-2 text-secondary--text"
    >
      Не удалось загрузить список
    </div>

    <v-list
      v-else
      class="py-0"
      data-qa="analyses_other_categories_list"
    >
      <v-list-item
        v-for="item in items"
        :key="item.id"
        :href="item.page_url"
        data-qa="analyses_other_category_item"
      >
        <v-list-item-content>
          <v-list-item-title class="text-body-1 text--text text-wrap">
            {{ item.name_short }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon class="align-self-center my-auto">
          <v-icon color="icon-secondary">
            ui-icon-arrow-right
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </CoreDrawer>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import CoreDrawer from 'src/core/CoreDrawer/CoreDrawer.vue'
import useContextStore from 'src/store/useContextStore'
import apiOtherCategories
  from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiOtherCategories'
import type { OtherCategoryItem }
  from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiOtherCategories.types'

const props = defineProps<{
  value: boolean
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

const { context } = useContextStore()

const items = ref<OtherCategoryItem[]>([])
const isLoading = ref(false)
const isError = ref(false)
const isLoaded = ref(false)

const loadItems = async () => {
  if (isLoaded.value || isLoading.value || !context.town?.translit) {
    return
  }

  isLoading.value = true
  isError.value = false

  try {
    items.value = await apiOtherCategories.get(context.town.translit)
    // eslint-disable-next-line require-atomic-updates
    isLoaded.value = true
  } catch {
    isError.value = true
  } finally {
    // eslint-disable-next-line require-atomic-updates
    isLoading.value = false
  }
}

watch(() => props.value, isOpen => {
  if (isOpen) {
    loadItems()
  }
})
</script>
